window.cpap.onDocumentReady(() => {
  /**
   * Populate the PDP desktop navigation submenu programmatically.
   *
   * 🚨👇 This is above-the-fold DOM rendering logic. DOM rendering code should
   * evaluate with the earliest priority, outside of post task scheduling.
   */
  const populatePdpSubMenu = (isReinitializing) => {
    document
      .querySelector('.shopify-section > div .shopify-block .yotpo-widget-instance')
      ?.setAttribute('anchor-id', 'Reviews');

    const pdpDesktopNavigationNode = document.querySelector(
      '.cpap__product-sub-menu__navigation-container--desktop'
    );

    const pdpMobileNavigationNode = document.querySelector(
      '.cpap__product-sub-menu__navigation-container--mobile'
    );

    const checkMobileInlineMenuOverflow = (entries) => {
      entries.forEach((entry) => {
        const hasOverflow = entry.target.scrollWidth > entry.target.clientWidth;
        entry.target.classList.toggle('is-scrollable', hasOverflow);
      });
    };

    const resizeObserver = new ResizeObserver(checkMobileInlineMenuOverflow);

    if (pdpMobileNavigationNode) {
      resizeObserver.observe(pdpMobileNavigationNode);
    }

    const anchorIds = document.querySelectorAll('[anchor-id]');

    anchorIds?.forEach((node, index) => {
      const anchorId = node.getAttribute('anchor-id');

      const divNode = document.createElement('div');
      divNode.classList.add('cpap__product-sub-menu__navigation-container__desktop-item');

      // Do not fade-in on reinitialization
      if (isReinitializing) {
        divNode.classList.add(
          'cpap__product-sub-menu__navigation-container__desktop-item--visible'
        );
      }

      const anchorNode = document.createElement('a');

      anchorNode.setAttribute('href', '#');
      anchorNode.dataset.anchor = anchorId;
      anchorNode.textContent = anchorId;

      if (index === 0) {
        anchorNode.classList.add('active');
      }

      divNode.appendChild(anchorNode);
      pdpDesktopNavigationNode.appendChild(divNode);

      const mobileAnchorNode = anchorNode.cloneNode(true);
      mobileAnchorNode.classList.add('cpap__product-sub-menu__navigation-container__mobile-item');

      if (isReinitializing) {
        mobileAnchorNode.classList.add(
          'cpap__product-sub-menu__navigation-container__mobile-item--visible'
        );
      }

      pdpMobileNavigationNode.appendChild(mobileAnchorNode);
    });

    // 👇 Schedule a user blocking post task to fade-in the dynamically added sub menu items. Do not fade-in on reinitialization.
    if (!isReinitializing) {
      window.scheduler.postTask(
        () => {
          ['desktop', 'mobile'].forEach((device) => {
            document
              .querySelectorAll(`.cpap__product-sub-menu__navigation-container__${device}-item`)
              ?.forEach((node) =>
                node.classList.add(
                  `cpap__product-sub-menu__navigation-container__${device}-item--visible`
                )
              );
          });
        },
        { priority: 'user-blocking' }
      );
    }

    // 👇 Schedule a user blocking post task to handle hovers on the sticky menu.
    window.scheduler.postTask(
      () => {
        const stickyHeaderNode = document.querySelector('.shopify-section-header-sticky');

        let isTouch = false;

        // Set flag when touch interaction occurs
        document.addEventListener(
          'touchstart',
          () => {
            isTouch = true;
          },
          { once: true }
        );

        stickyHeaderNode.addEventListener('mouseenter', (event) => {
          // Skip if the interaction was triggered by touch
          if (isTouch) {
            isTouch = false;
            return;
          }

          const isScrolledDown = stickyHeaderNode.classList.contains('cpap-scroll-to-down');
          stickyHeaderNode.classList.add(
            `cpap-scroll-to-${isScrolledDown ? 'down' : 'top'}--hovered`
          );
        });

        stickyHeaderNode.addEventListener('mouseleave', (event) => {
          // Skip if the interaction was triggered by touch
          if (isTouch) {
            isTouch = false;
            return;
          }

          ['down', 'top'].forEach((direction) =>
            stickyHeaderNode.classList.remove(`cpap-scroll-to-${direction}--hovered`)
          );
        });
      },
      { priority: 'user-blocking' }
    );

    // 👇 Schedule a post task to handle scrolling to the proper page section when a sub-menu item is clicked
    window.scheduler.postTask(
      () => {
        const nodeToTargetEntriesMap = [];

        document
          .querySelectorAll('.cpap__product-sub-menu__navigation-container a')
          .forEach((node) => {
            const anchorId = node.dataset?.anchor;

            if (anchorId) {
              const targetNode = document.querySelector('[anchor-id="' + anchorId + '"]');

              if (targetNode) {
                const targetAccordionBodyNode = targetNode.querySelector(
                  '.cpap__product-specifications__accordion-collapse'
                );
                nodeToTargetEntriesMap.push([node, targetNode, targetAccordionBodyNode]);
              }
            }
          });

        if (nodeToTargetEntriesMap.length) {
          const hasDefaultProductSpecs = Boolean(
            document.querySelector('.cpap__product-specifications__container')
          );

          nodeToTargetEntriesMap.forEach(([node, targetNode, targetAccordionBodyNode]) => {
            node.addEventListener('click', (event) => {
              event.preventDefault();

              pdpDesktopNavigationNode?.classList.remove(
                'cpap__product-sub-menu__navigation-container--desktop--expanded'
              );

              const isOpenableAccordion = hasDefaultProductSpecs && targetAccordionBodyNode;

              if (isOpenableAccordion) {
                // Load the script logic for the accordions that will be scrolled into view
                window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapProductSpecsJs, {
                  onload: () => {
                    window.scheduler.postTask(
                      () => {
                        document
                          .querySelectorAll('.cpap__product-specifications__accordion-item')
                          .forEach((node) => {
                            const headerNode = node.querySelector(
                              '.cpap__product-specifications__accordion-header'
                            );

                            if (!headerNode) {
                              return;
                            }

                            headerNode.classList.remove('is-active');

                            const accordionClassList = node.querySelector(
                              '.cpap__product-specifications__accordion-collapse'
                            ).classList;

                            accordionClassList.add(
                              'cpap__product-specifications__accordion-collapse--no-transition'
                            );
                            accordionClassList.remove(
                              'cpap__product-specifications__accordion-collapse--expanded'
                            );

                            headerNode.querySelector('span').textContent = 'More';
                          });

                        setTimeout(() => {
                          targetNode
                            .querySelector('.cpap__product-specifications__accordion-header')
                            .click();

                          window.cpap.dynamicallyLoadScript(
                            window.cpap.cdnSources.cpapJitUtilitiesJs,
                            {
                              onload: () => {
                                window.cpap.scrollToPdpTargetNode(targetNode, 10);

                                document
                                  .querySelectorAll(
                                    '.cpap__product-specifications__accordion-collapse'
                                  )
                                  .forEach((node) => {
                                    node.classList.remove(
                                      'cpap__product-specifications__accordion-collapse--no-transition'
                                    );
                                  });
                              },
                            }
                          );
                        }, 0);
                      },
                      { priority: 'user-blocking' }
                    );
                  },
                });
              } else {
                window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapJitUtilitiesJs, {
                  onload: () => {
                    window.cpap.scrollToPdpTargetNode(targetNode, 10);
                  },
                });
              }
            });
          });
        }
      },
      {
        priority: 'user-blocking',
      }
    );

    // 👇 Schedule a user blocking post task for the share button popover
    window.scheduler.postTask(
      () => {
        const initializePdpProductSharePopover = () => {
          document.querySelector('.cpap__product-share-popover__button')?.addEventListener(
            'click',
            (event) => {
              event.stopPropagation();

              window.scheduler.postTask(
                () => {
                  window.cpap.activateVisibilityObserver('.cpap__product-share-popover__icons a');
                },
                { priority: 'user-visible' }
              );

              event.currentTarget
                .querySelector('.cpap__product-share-popover__icons')
                .classList.toggle('cpap__product-share-popover__icons--show');
            },
            { passive: true }
          );

          document.body.addEventListener(
            'click',
            () => {
              document
                .querySelector('.cpap__product-share-popover__icons')
                ?.classList.remove('cpap__product-share-popover__icons--show');
            },
            { passive: true }
          );
        };

        initializePdpProductSharePopover();
      },
      { priority: 'user-blocking' }
    );
  };

  populatePdpSubMenu();
  // 👇 This will be used to re-initialize after a user-driven variant change event on the PDP pages.
  window.cpap.populatePdpSubMenu = populatePdpSubMenu;

  /**
   * Populate the PDP desktop navigation submenu programmatically.
   *
   * 🚨👇 This is above-the-fold DOM rendering logic. DOM rendering code should
   * evaluate with the earliest priority, outside of post task scheduling.
   */
  const truncatePdpProductDescriptionDetails = () => {
    document.querySelectorAll('.text-read-more-hide').forEach((node) => {
      // Find the text content of the current element
      const textContent = node.textContent;

      node.replaceChildren();

      // Split the text into an array of words
      const words = textContent.split(/\s+/);

      // Get the first 20 words
      const firstTwentyWords = words.slice(0, 20).join(' ');

      // Create a new <p> element
      const paragraph = document.createElement('p');

      // Create a text node for the truncated text
      const textNode = document.createTextNode(firstTwentyWords);

      // Append the text node to the <p> element
      paragraph.appendChild(textNode);

      // Check if more than 20 words exist
      if (words.length > 20) {
        // Create the "Read more" link
        const readMoreLinkNode = document.createElement('a');
        readMoreLinkNode.href = '#';
        readMoreLinkNode.className = 'read-more-first';
        readMoreLinkNode.textContent = '[Read more ...]';

        readMoreLinkNode.addEventListener('click', (event) => {
          event.preventDefault();

          window.scheduler.postTask(
            () => {
              document.querySelector('[data-anchor="Details"]').click();
            },
            { priority: 'user-visible' }
          );
        });

        // Add a space before the link and append it to the paragraph
        paragraph.appendChild(document.createTextNode(' '));
        paragraph.appendChild(readMoreLinkNode);
      }

      // Append the <p> element to the original node
      node.appendChild(paragraph);

      node.classList.add('is-visible');
    });
  };

  truncatePdpProductDescriptionDetails();
  // 👇 This will be used to re-initialize after a user-driven variant change event on the PDP pages.
  window.cpap.truncatePdpProductDescriptionDetails = truncatePdpProductDescriptionDetails;

  const addSubMenuExpandButtonClickHandler = () => {
    document
      .querySelector('.cpap__product-sub-menu__mobile-expand-button a')
      ?.addEventListener('click', (event) => {
        event.preventDefault();

        document
          .querySelector('.cpap__product-sub-menu__navigation-container--desktop')
          ?.classList.toggle('cpap__product-sub-menu__navigation-container--desktop--expanded');
      });
  };

  // 👇 This will be used to re-initialize after a user-driven variant change event on the PDP pages.
  window.cpap.addSubMenuExpandButtonClickHandler = addSubMenuExpandButtonClickHandler;

  // 🚨👇 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  // 👇 Schedule a user blocking post task for the mobile navigation menu event listener
  window.scheduler.postTask(
    () => {
      addSubMenuExpandButtonClickHandler();
    },
    { priority: 'user-blocking' }
  );

  // 🚨👇 This is only for user-visible logic. Nothing that is user-blocking or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      // Keep track of the active timeout to avoid duplicate drawers queuing
      let activeTimeout = null;

      // 👇 This click listener is designated as `user-visible` because it adds a nice-to-have feature
      // that will auto open a section flyout if it exists. The scroll-to functionality will still work
      // if they happen to click the button before the page finishes loading, which would be an edge case.
      const initiateDelayedFlyoutAutoOpening = () => {
        const nodeToTargetEntriesMap = [];
        document
          .querySelectorAll('.cpap__product-sub-menu__navigation-container a')
          .forEach((node) => {
            const anchorId = node.dataset?.anchor;

            if (anchorId) {
              const targetNode = document.querySelector('li[anchor-id="' + anchorId + '"]');

              if (targetNode) {
                const targetButtonNode = targetNode.querySelector(
                  'button[data-bs-toggle="offcanvas"]'
                );

                if (targetButtonNode) {
                  nodeToTargetEntriesMap.push([node, targetButtonNode]);
                }
              }
            }
          });

        if (nodeToTargetEntriesMap.length) {
          // Global cancellation token to track active click events
          let currentCancellationToken = 0;

          nodeToTargetEntriesMap?.forEach(([node, targetButtonNode], index) => {
            node.addEventListener('click', async (event) => {
              event.preventDefault();
              const eventCancellationToken = ++currentCancellationToken; // Increment the current cancellation token before assigning
              const targetNode = targetButtonNode?.parentElement;

              if (activeTimeout) {
                clearTimeout(activeTimeout);
                activeTimeout = null;
              }

              // Add small timeout to allow scrolling to begin.
              activeTimeout = setTimeout(async () => {
                if (targetNode) {
                  // Wait for scroll animation to complete
                  await window.cpap.waitForScrollToComplete();

                  // Check if this click event is still valid
                  if (eventCancellationToken === currentCancellationToken) {
                    targetButtonNode.click();
                  }
                }
              }, 50);
            });
          });
        }
      };

      // 👇 This scroll listener is designated as `user-visible` because it does not prevent a
      // user from interacting with the site, it only updates menu highlighting during scrolling.
      const initiateSubMenuActiveHighlightingOnScroll = () => {
        window.cpap.dynamicallyLoadScript(window.cpap.cdnSources.cpapJitUtilitiesJs, {
          onload: () => {
            // Select all elements with the attribute `[anchor-id]` on the page
            const anchorNodes = document.querySelectorAll('[anchor-id]');
            const subMenuNavigationLinkNodes = document.querySelectorAll(
              '.cpap__product-sub-menu__navigation-container a'
            );

            let previousScroll = 0;

            const scrollEventListener = () => {
              // Get window scroll position and height
              const scrollY = window.scrollY;
              const scrollOffset = window.cpap.getPdpStickyMenuScrollOffset(
                scrollY,
                previousScroll
              );

              previousScroll = scrollY;

              // Determine window width
              const isMobile = window.innerWidth <= window.appConfig.MOBILE_WIDTH_THRESHOLD_2;
              const limitBottomOffset = isMobile ? 20 : 6;

              // Iterate through each anchor element
              anchorNodes.forEach((node) => {
                const nodeTopY = window.cpap.getScrollToLocation(node, scrollOffset);
                const nodeBottomY = nodeTopY + node.offsetHeight;

                const adjustedScrollY = scrollY + limitBottomOffset;

                if (scrollY <= nodeBottomY && nodeTopY <= adjustedScrollY) {
                  const anchorIdentifier = node.getAttribute('anchor-id');

                  // Update navigation links
                  setTimeout(() => {
                    subMenuNavigationLinkNodes.forEach((link) => {
                      const isActiveAnchorElement = link.textContent === anchorIdentifier;
                      link.classList[isActiveAnchorElement ? 'add' : 'remove']('active');

                      // If link becomes active and is in a scrollable container, scroll it into view.
                      if (isActiveAnchorElement) {
                        const mobileInlineMenuScrollContainer = document.querySelector(
                          '.cpap__product-sub-menu__navigation-container--mobile'
                        );

                        // Check if scrollable container
                        if (
                          mobileInlineMenuScrollContainer?.scrollWidth >
                          mobileInlineMenuScrollContainer?.clientWidth
                        ) {
                          const containerRect =
                            mobileInlineMenuScrollContainer.getBoundingClientRect();
                          const linkRect = link.getBoundingClientRect();

                          // Calculate the relative position of the link within the container
                          const linkRelativeLeft = linkRect.left - containerRect.left;
                          const linkRelativeRight = linkRect.right - containerRect.left;

                          // If link is not fully visible
                          if (linkRelativeLeft < 0 || linkRelativeRight > containerRect.width) {
                            // Calculate target scroll position to center the element
                            const targetScroll =
                              mobileInlineMenuScrollContainer.scrollLeft +
                              linkRelativeLeft -
                              (containerRect.width - linkRect.width) / 2;

                            // Simple smooth scroll without animation
                            mobileInlineMenuScrollContainer.scrollTo({
                              left: targetScroll,
                              behavior: 'smooth',
                            });
                          }
                        }
                      }
                    });
                  });
                }
              });
            };

            document.addEventListener('scroll', window.cpap.throttle(scrollEventListener, 50), {
              passive: true,
            });
          },
        });
      };

      // 👇 This will be used to re-initialize after a user-driven variant change event on the PDP pages.
      window.cpap.initiateSubMenuActiveHighlightingOnScroll =
        initiateSubMenuActiveHighlightingOnScroll;

      initiateDelayedFlyoutAutoOpening();
      initiateSubMenuActiveHighlightingOnScroll();
    },
    { priority: 'user-visible' }
  );
});
